const SBDisclaimerConfig = {
	Title: "Disclaimer Tool",
	AppID: "SBDisclaimer",

	CLIENT_ID: '170764070601-s6m88vafpqf9oeho9qq7o845g22tutde.apps.googleusercontent.com',
	API_KEY: 'AIzaSyBSvxvmgZaiFxBGiraq8m88umSpaABxtWs',

	/*
	Spreadsheet columns are from left to right: Key (ID) value, then 'Regions' (tabs), then the disclaimer data keys. 
	
	Warning: When adding a column, be sure to update SHEET_RANGE and SHEET_RANGE_RTF 
	*/

	//SHEET_ID : "1mGduhheVsYm1EBEegUFUDcHWIaihibOdqhTMGxjL3Jc",
	SHEET_ID : "1u8wQXRM0JTOrZkXGmX8FfENFRZVk8JdaycqlobSrDmM",
	SHEET_RANGE: 'SBDisclaimers!A2:S',
	SHEET_RANGE_RTF: 'SBDisclaimers!S2:S',

	UserSettingsSheet: false, 

	FormClass: 'sb-disclaimer-form', 
	DisplayRTF: true, 
	AllowReordering: false, 
	StickyLegalText: false, 
	DefaultLoginMode: 1,

	RegionKeys: ['oldcharter', 'consolidated', 'standard', 'combined', 'website', 'reach', 'newsmb', 'tvclaims', 'sbpp4', 'enterprise'],
	DataKeys: ['section', 'type', 'offertype', 'desc', 'bold', 'symbol', 'tip', 'copy'],
	LegalColumn: 'copy', 
	TipColumn: 'tip', 

	RegionSection: "Region",
	OfferTypeSection: "OfferType",
	OfferTypeAll : "alloffertypes", 

	Sections : [
		{ "key": "Region",
			"label": "Region",
			"type": "tabs"
		},
		{ "key" : "OfferType" , 
			"label" : "Offer Type",
			"type" : "tabs", 
			"filterRegion": true, 
			"autoSelect" : true
		},
		{ "key": "Intro",
			"label" : "Intro Disclaimer",
			"type": "single" ,
			"filterRegion": true, 
			"filterOfferType" : false,
			"autoSelect" : true
		},
		{ "key": "Internet",
			"type": "multiple" ,
			"filterRegion": true, 
			"filterOfferType" : true,
		  "product": "I",
		},
		{ "key": "Phone",
			"type": "multiple" ,
			"filterRegion": true, 
			"filterOfferType" : false,
		  "product": "P" 
		},
		{
			"key": "BusinessConnect",
			"label": "Spectrum Business Connect",
			"type": "multiple",
			"filterRegion": true,
			"filterOfferType": false,
		},
		{ "key": "TV",
			"type": "multiple" ,
			"filterRegion": true, 
			"filterOfferType" : false,
			"product": "T" 
		},
		{
			"key": "NewMobile",
			"label": "Mobile",
			"type": "multiple",
			"filterRegion": true,
			"filterOfferType": false,
		},
		{
			"key": "EnterpriseOffer",
			"label": "Enterprise Offer",
			"type": "multiple",
			"filterRegion": true,
			"filterOfferType": false,
		},
		{
			"key": "ChoiceBundles",
			"label": "Choice Bundles",
			"filterOfferType": true,
			"filterRegion": true,
			"type": "multiple"
		},
		{ 
			"key": "BundleOffers",
			"label": "Bundle Offers",
			"filterOfferType" : true,
			"filterRegion": true, 
			"type": "multiple" 
		},
		{
			"key": "FreePhoneBundles",
			"label": "Free Phone Offer Bundles",
			"filterOfferType": true,
			"filterRegion": true,
			"type": "multiple"
		},
		{
			"key": "BundleSavings",
			"label": "Bundle Savings",
			"filterOfferType": true,
			"filterRegion": true,
			"type": "multiple"
		},
		{ "key": "BarRestaurant",
			"label": "Bar Restaurant",
			"type": "multiple",
			"filterRegion": true,
			"filterOfferType" : true
		},
		{ "key": "PriceComparison",
			"label": "Price Comparison",
			"type": "multiple",
			"filterRegion": true,
			"filterOfferType" : true
		},
		{ "key": "BarRestaurantPriceComparison",
			"label": "Bar Restaurant Price Comparison",
			"type": "multiple",
			"filterRegion": true,
			"filterOfferType" : true
		},	
		{ "key": "InternetComparison",
			"label": "Internet Comparison",
			"type": "multiple", 
			"filterRegion": true, 
			"filterOfferType" : true },	
		{ "key": "PhoneComparison",
			"label": "Phone Comparison",
			"type": "multiple",
			"filterRegion": true, 
			"filterOfferType" : false },
		{ "key": "PriceGuarantee",
			"label": "2-Year Price Guarantee",
			"type": "multiple",
			"filterRegion": true,
			"filterOfferType" : true
		},
		{
			"key": "CompetitiveCampaign",
			"label": "Competitive Campaign Concept",
			"type": "multiple",
			"filterRegion": true,
			"filterOfferType": true
		},	
		{ "key": "Claims",
			"label": "General Claims",
			"type": "multiple",
			"filterRegion": true,
			"filterOfferType" : false,
		},
		{
			"key": "Upgrade",
			"label": "Upgrade",
			"type": "multiple",
			"filterRegion": true,
			"filterOfferType": false,
		},
		{
			"key": "CountOnUs",
			"label": "Count on Us",
			"type": "multiple",
			"filterRegion": true,
			"filterOfferType": false,
		},
		{
			"key": "NoNonsense",
			"label": "No Nonsense",
			"type": "multiple",
			"filterRegion": true,
			"filterOfferType": false,
		},
		{
			"key": "Ookla",
			"label": "Ookla",
			"type": "multiple",
			"filterRegion": true,
			"filterOfferType": false,
		},
		{
			"key": "FreeMobile",
			"label": "Free Mobile",
			"type": "multiple",
			"filterRegion": true,
			"filterOfferType": false,
		},
		{
			"key": "FCCClaims",
			"label": "FCC Claims",
			"type": "multiple",
			"filterRegion": true,
			"filterOfferType": false,
		},
		{
			"key": "FastestSpeedClaims",
			"label": "Fastest Speed Claims",
			"type": "multiple",
			"filterRegion": true,
			"filterOfferType": false,
		},
		{ "key": "FreeInstall",
			"label": "Free Install Offer",
			"type": "multiple",
			"filterRegion": true,
			"filterOfferType" : false,
		},
		{
			"key": "ReachOffer",
			"label": "Reach Offer",
			"type": "single",
			"filterRegion": true,
			"filterOfferType": false,
			"autoSelect": true
		},
		{ "key": "EndDisclaimer",
			"label": "End Disclaimer",
			"type": "single",
			"filterRegion": true, 
			"filterOfferType" : true,
			"autoSelect" : true
		},	
		{ "key": "OptOut",
			"label": "Tactical Disclaimers",
			"type": "single",
			"filterRegion": true, 
			"filterOfferType" : false,
			"autoSelect" : true
		}		
	],

	SecretPassword: "d10c141503d313138374bd4169150ebcc3b13a0b",
	OLDSecretPassword: "ca3979a3fb9356b99af9ccfad192ea6dea929c73",

	/* methods */
	
	// return array of section names 
	getSections : function() {
		let out = [];
		this.Sections.forEach( (sec) => {
			out.push(sec.key);
		});
		return out; 
	},

	
};

export default SBDisclaimerConfig;
